import { MantineDataTable } from '@flexinet/ui-components';
import { Stack } from '@mantine/core';
import { useAllAliases } from '../hooks/useAllAliases';
import { useAliasesTableColumns } from '../hooks/useAliasesTableColumns';
import { DataTableTokenPagination } from '../../../components/DataTableTokenPagination';
import { useRef } from 'react';

export const AliasesTable = () => {
    const { visibleItems, loading, nextToken, fetchRecords, isFetchingNextPage, visibleCount } = useAllAliases();
    const columns = useAliasesTableColumns();
    const scrollViewportRef = useRef<HTMLDivElement>(null);

    return (
        <Stack gap="lg">
            <MantineDataTable
                columns={columns}
                records={visibleItems}
                fetching={loading}
                withTableBorder={true}
                onScrollToBottom={fetchRecords}
                scrollViewportRef={scrollViewportRef}
            />
            <DataTableTokenPagination
                totalCount={visibleCount.toString()}
                nextToken={nextToken}
                handleLoadMore={fetchRecords}
                loading={isFetchingNextPage}
            />
        </Stack>
    );
};
